import { render, staticRenderFns } from "./NotLoggedIn.vue?vue&type=template&id=68af5695"
import script from "./NotLoggedIn.vue?vue&type=script&lang=js"
export * from "./NotLoggedIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports